import { useMemo } from "react";

export const FooterLinks = () => {

    const footerArr = useMemo(() => {
        return [
            {
                title: "Links:",
                text: "Useful Links",
                list: [
                    "Home",
                    "About Us",
                    "Services",
                    "Industry",
                    "Founder",
                    "Contact Us"
                ],
            },
            {
                title: "Industries:",
                text: "Range of industries",
                list: [
                    "Civil Engineering",
                    "Construction Engineering",
                    "Quantity Surveying",
                    "Architecture",
                    "Mining"
                ],
            },
            // {
            //     title: "Services:",
            //     text: "Services We Provide",
            //     list: [
            //         "Head Hunting",
            //         "Executive Searches ",
            //         "Candidate Services"
            //     ],
            // },
        ];
    }, []);

    return (
        <div className="links-wrap">
            {footerArr.map((foot, index) => (
                <div key={index} className="footer-link">
                    <h3>{foot.title}</h3>
                    <p>{foot.text}</p>
                    {/* <div className="line" /> */}
                    <ul>
                        {foot.list.map((li, index) => (
                            <li key={index}>{li}</li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}